module.exports = __webpack_public_path__ + "static/media/polinizador.b38e4f26.svg";